module.exports = __webpack_public_path__ + "img/1-4.d7861a7c.jpg";